import styled from 'styled-components';

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ExpandedColumn = styled(Column as any)`
  min-height: calc(100vh - 120px);
  height: 100%;
  @media (max-width: 991px) {
    height: 100%;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ExpandedSingleChildColumn = styled(Column as any)`
  height: calc(100vh - 120px);
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FullHeightColumn = styled(Column as any)`
  height: 100%;
`;
